import Page from '../../page';

export default class ProductsEntry extends Page {
	constructor(...args) {
		super(...args);

		this._retrieveDOM();
		this._initTls();
	}

	_retrieveDOM(){
		super._retrieveDOM();

		this.dom.buttons = this.dom.page.querySelector('.js-buttons');
		this.dom.weight = this.dom.buttons.querySelectorAll('.js-button-weight');
		this.dom.link = this.dom.buttons.querySelector('.js-button-download');
		this.dom.pictures = this.dom.page.querySelectorAll('.js-picture-product');
		this.dom.btnContact = this.dom.page.querySelector('.js-btn-contact .button-link');
	}

	bind() {
		for (let i = 0; i < this.dom.weight.length; i++) {
			let el = this.dom.weight[i];
			el.addEventListener('click', this._updateButton.bind(this, i));
		}
	}

	_updateButton(index) {
		this._removeAllBtn();

		this.dom.weight[index].classList.add('active');
		if (this.dom.page.getAttribute('target-id'))
			this.dom.link.setAttribute('href', dataProductSheets.file[index]);
        this.dom.btnContact.setAttribute( 'href', dataProductSheets.url_contact[index] )
		for (let i = 0, j = this.dom.pictures.length; i < j; i ++) {
            this.dom.pictures[i].setAttribute('src', dataProductSheets.picture[index]);
        }
		window.history.pushState('', '', dataProductSheets.url[index]);
	}

	_removeAllBtn() {
		for (let i = 0; i < this.dom.weight.length; i++) {
			this.dom.weight[i].classList.remove('active');
		}
	}

	/**
	 * init() {}
	 * bind() {}
	 * unbind() {}
	 * resize(width, height) {}
	 * _destroy() {}
	 */
}



// WEBPACK FOOTER //
// ./src/js/pages/products/entry/products-entry.js